export const API_ENDPOINTS = {
  ATTACHMENTS: "attachments",
  ATTACHMENTS_URLS: "attachments/url",
  ANALYTICS: "analytics",
  ANALYTICS_BY_MONTH: "analytics/byMonth",
  ADDRESS: "address",
  ATTRIBUTES: "attributes",
  ATTRIBUTE_VALUES: "attribute-values",
  ORDER_STATUS: "order-status",
  ORDERS: "orders",
  ORDERS_SELECTED: "orders/selected",
  ORDER_ANALYTICS: "order-analytics",
  EXPORT_ORDER_ANALYTICS: "order-analytics/export",
  ORDER_ATTRIBUTES: "order-attributes",
  ORDER_EXPORT: "orders/export",
  VERIFY_ORDER: "orders/checkout/verify",
  INVOICES: "invoices",
  SHIPMENTS: "shipments",
  CREDIT_MEMO: "credit-memo",
  REFUNDS: "refunds",
  BANNERS: "banners",
  BANNERS_BY_TYPE: "banners-by-type",
  BRANCH: "branch",
  EXPORT_HISTORY: "export-history",
  DEALS: "deals",
  USERS: "users",
  USERS_IMPORT: "users/import",
  USERS_DELETE: "users/delete",
  USERS_RESTORE: "users/restore",
  STORE_IMPORT: "stores/import",
  REGISTER: "register",
  PRODUCTS: "products",
  PRODUCTS_EXPORT: "products/export",
  PRODUCTS_IMPORT: "products/import",
  PRODUCTS_PREVIEW: "products/preview",
  PRODUCTS_QUICK_UPDATE: "products/quick-update",
  POPULAR_PRODUCTS: "popular-products",
  VOUCHERS: "vouchers",
  MEDIA_S3_URL: "media/signed/url",
  DISCOUNTS: "discounts",
  COUPONS: "coupons",
  PROMOTIONS: "promotions",
  CUSTOMERS: "customers",
  USERS_EXPORT: "users/export",
  SEARCH_TERMS_EXPORT: "search_terms/export",
  WALLET_TRANSACTIONS_EXPORT: "wallet_transactions/export",
  CUSTOMER_GROUPS: "customer_groups",
  TAXES: "taxes",
  SHIPPINGS: "shippings",
  SHIPPING_ZONES: "shipping_zones",
  SETTINGS: "settings",
  STATES: "states",
  CATEGORIES: "categories",
  BATCH_CATEGORIES: "batch-categories",
  LOCATIONS: "locations",
  TAGS: "tags",
  PARENT_CATEGORIES: "categories-nav",
  PRODUCTS_BY_CATEGORY: "products-by-category",
  NAV_CATEGORIES: "fetch-nav-category",
  BRAND_CATEGORIES: "fetch-brand-category",
  UPDATE_NAV_CATEGORIES: "update-nav-category",
  UPDATE_BRAND_CATEGORIES: "update-brand-category",
  TYPES: "types",
  PAYMENT_GATEWAYS: "payment_gateways",
  PAYMENT_METHODS: "payment_methods",
  WALLET_GROUPS: "wallet/groups",
  WALLETS: "wallets",
  WALLET_TRANSACTIONS: "wallet_transactions",
  STATIC_BLOCKS: "static_blocks",
  UPDATE_STATIC_BLOCKS_SORTING: "sort-static-block",
  // Its own path rather than /static_blocks/featured, which the API's
  // apiResource would capture as an {id}.
  UPDATE_STATIC_BLOCK_FEATURED: "featured-static-block",
  SEARCH_TERMS: "search_terms",
  NOTIFICATION_TEMPLATES: "notification_templates",
  BLOCKED_DOMAINS: "blocked_domains",
  PROFILE_UPDATE: "profile-update",
  LOGOUT: "logout",
  ME: "me",
  TOKEN: "admin-token",
  AUTH_SETUP: "auth/setup",
  AUTH_PIN_CHECK: "auth/pin-check",
  BLOCK_USER: "users/block-user",
  UNBLOCK_USER: "users/unblock-user",
  CHANGE_PASSWORD: "change-password",
  FORGET_PASSWORD: "forget-password",
  VERIFY_FORGET_PASSWORD_TOKEN: "verify-forget-password-token",
  ROLES: "roles",
  RESET_PASSWORD: "reset-password",
  DOWNLOAD_INVOICE: "download/invoice",
  APPROVE_SHOP: "approve-shop",
  DISAPPROVE_SHOP: "disapprove-shop",
  SHOPS: "all-shop",
  MY_SHOPS: "my-shops",
  WITHDRAWS: "withdraws",
  APPROVE_WITHDRAW: "approve-withdraw",
  STAFFS: "staffs",
  ADD_STAFF: "users/add-staff",
  STORES: "stores",
  SCHEDULE_NOTIFICATIONS: "schedule-notifications",
  MEMBERSHIPS: "membership-tiers",
  MEMBERSHIP_TIER: "membership-tiers-list",
  PROXY_PDF: "proxy/pdf",
  ORDERS_BULK_UPDATE_STATUS: "/orders/bulk-update-status",
};
